import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import './checks.scss'
import CheckDetailTitle from './CheckDetailTitle'
import CheckRiskStatus from '../components/CheckRiskStatus'
import TimelineDotLine from '../components/TimelineDotLine'

const CheckDebtor = ({ debtorsCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])

  const hasChecks = Boolean(debtorsCheck?.checkDetails?.DebtorName)
  const checkLength = debtorsCheck?.checkDetails?.TotalDebts || 0

  const formatBRL = (value) => {
    if (typeof value !== 'number') return '---'
    return `R$${value.toLocaleString('pt-BR')}`
  }

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:governmentDebtors')}</Typography>
        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} label="Dívida" />
      </Paper>

      <CheckDetailTitle
        email={debtorsCheck?.email}
        status={debtorsCheck?.status}
        createdAt={debtorsCheck?.createdAt}
        updatedAt={debtorsCheck?.updatedAt}
      />

      {!hasChecks && debtorsCheck?.checkDetails?.informação && (
        <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
          <Typography variant="subtitle1">{t('common:information')}</Typography>
          <Typography variant="subtitle3">{debtorsCheck.checkDetails.informação ?? '---'}</Typography>
        </Paper>
      )}

      {hasChecks && (
        <TimelineDotLine>
          <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
            <div className="c-detail-grid">
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:debtorName')}</Typography>
                <Typography variant="subtitle3">{debtorsCheck.checkDetails.DebtorName ?? 'No debts'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:totalDebtValue')}</Typography>
                <Typography variant="subtitle3">
                  {debtorsCheck.checkDetails.TotalDebtValue
                    ? formatBRL(debtorsCheck.checkDetails.TotalDebtValue)
                    : '---'}
                </Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:totalDebts')}</Typography>
                <Typography variant="subtitle3">{debtorsCheck.checkDetails.TotalDebts ?? '---'}</Typography>
              </div>
              {debtorsCheck.checkDetails.informação && (
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:data')}</Typography>
                  <Typography variant="subtitle3">{debtorsCheck.checkDetails.informação}</Typography>
                </div>
              )}
            </div>
          </Paper>
        </TimelineDotLine>
      )}
    </>
  )
}

export default CheckDebtor
